export default "__VITE_ASSET__4d0e87f1__"